export default {
  route: {
    getLocationErr: 'Failed to get location information',
    backHome: 'Back to home page',
    changePassword: 'Change Password',
    logOut: 'Log out'
  },
  navbar: {
  },
  login: {
    title: 'Login Form',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
  },
  documentation: {
  },
  permission: {
  },
  guide: {
  },
  components: {
  },
  table: {
    add: 'Add',
    export: 'Export',
    import: 'Import',
    download: 'DownloadTemplate',
    id: 'ID',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    input: 'PleaseInput-',
    select: 'PleaseSelect-',
    close: 'Close',
    save: 'Save',
    submit: 'Submit',
    yes: 'Yes',
    no: 'No',
    failure: 'Failure',
    view: 'Check',
    logistics: 'Logistics information',
    onlineContact: 'Online contact',
    abnormalReport: 'Abnormal report',
    abnormalDetail: 'Details of difference handling',
    orderDetail: 'Order detail',
    upload: 'File upload',
    editBoxNumber: 'Modify the number of cases',
    editAddress: 'Change address',
    orderList: 'Order list',
  },
  week: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
  },
  errorLog: {
    documentation: 'Document introduction'
  },
  excel: {
    tip: 'Tip: import files in xlsx / XLS format only',
  },
  zip: {

  },
  pdf: {
  },
  image: {
    tip: 'Tip: you must select the suffix. JPG or. PNG picture file (picture name: order number_ 001.jpg, order No_ 002.jpg)'
  },
  theme: {
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  comm: {
    success: 'Success',
    deleteMsg: 'Are you sure to delete the selected record？',
    createTime: 'CreateTime',
    creator: 'Creator',
    updateTime: 'UpdateTime',
    updater: 'Updater',
    reset: 'Reset',
    search: 'Search'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js